import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { set } from 'firebase/database';
import { Spinner } from 'reactstrap';
import { BASE_URL } from '../config';


export default function DoctorProfile() {
  const { id } = useParams();
  const [doctorList, setDoctorList] = useState([]);
  const navigate = useNavigate();  // Initialize navigate function

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDoctorProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}DoctorProfile?id=${id}`, {
          method: 'POST',
          headers: {
            'Accept': 'text/plain',
          },
        });

        const data = await response.json();
        if (response.ok) {
          setLoading(false);
          setDoctorList(data.doctorList);
        } else {
          setLoading(false);
          alert(data.message);
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching doctor profile:', error);
      }
    };

    fetchDoctorProfile();
  }, [id]); // Include 'id' in the dependency array

  const handleEditClick = () => {
    navigate(`/DoctorProfileEdit/${id}`);  // Route to the edit page with the doctor ID
  };

  const handleInfoEditClick = () => {
    navigate(`/DoctorProfileInfoEdit/${id}`);
  };

  const formatDutyTime = (timeRange) => {
    if (!timeRange) return 'N/A';

    const formatTime = (time) => {
      const [hour, minute] = time.split(':');
      const h = parseInt(hour);
      const ampm = h >= 12 ? 'PM' : 'AM';
      const formattedHour = h % 12 || 12;
      return `${formattedHour}:${minute} ${ampm}`;
    };

    const [start, end] = timeRange.split(' - ');
    return `${formatTime(start)} - ${formatTime(end)}`;
  };


  return (
    <Container fluid className='h-custom py-1'>
      <Header />

      <Row className='d-flex justify-content-center align-items-center h-45 mt-3'>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
            <Spinner size="lg" />
          </div>
        ) :

          doctorList.length > 0 && (
            <Col xs="12" sm="12" md="12" lg="12" className="mt-1">
              <Card className='card-registration card-registration-2' style={{ borderRadius: '15px' }}>
                <Card.Header className="text-center bg_primary text-white">
                  <Row>
                    <Col xs="8" sm="8" md="10" lg="11">
                      <div className="d-flex justify-content-center align-items-center">
                        <h5 className="fw-bold mb-1 mt-2">Doctor Profile</h5>
                      </div>
                    </Col>
                    <Col xs="4" sm="4" md="2" lg="1">
                      <div className="d-flex justify-content-center align-items-center ">
                        <Button variant="primary" className="w-100 bg-white text_primary" size="md" onClick={handleEditClick}>Edit</Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Header>

                <Card.Body className='p-0'>
                  <Row>
                    <Col xsm="12" sm="12" md="4" lg="3">
                      <Card className="shadow-none">
                        <Card.Body className="text-center pb-1">
                          <Card.Img
                            src={doctorList[0].image}
                            alt="avatar"
                            className="rounded-circle img-thumbnail"
                            style={{ width: '150px', height: '150px', borderColor: "#50c4cc" }}
                            fluid />
                          <p className="text-muted m-2">
                            {doctorList[0].specialization}
                            <br />
                            {doctorList[0].city}
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col xsm="12" sm="12" md="8" lg="9">
                      <Card className="shadow-none">
                        <Card.Body>
                          {/* <hr /> */}
                          <Row>
                            <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>Full Name</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted">{doctorList[0].name}</Card.Text>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <hr />
                          <Row>
                            <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>Qualification</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted">{doctorList[0].allqualifications}</Card.Text>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <hr />
                          <Row>
                            <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>Birth Date</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted"> {new Date(doctorList[0].dateOfBirth).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })}</Card.Text>
                                </Col>
                              </Row>
                              <hr />
                            </Col>
                            <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>CNIC</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted">{doctorList[0].cnic}</Card.Text>
                                </Col>
                              </Row>
                              <hr />
                            </Col>

                          </Row>

                          <Row>
                            <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>Gender</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted text-capitalize">{doctorList[0].gender}</Card.Text>
                                </Col>
                              </Row>
                              <hr />
                            </Col>
                            <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>Duty Time</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted">{formatDutyTime(doctorList[0].doctorDutyTime)}</Card.Text>
                                </Col>
                              </Row>
                              <hr />
                            </Col>
                            {/* <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>CNIC</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted">{doctorList[0].cnic}</Card.Text>
                                </Col>
                              </Row>
                              <hr />
                            </Col> */}
                          </Row>



                          {/* <Row>
                            <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>Birth Date</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted"> {new Date(doctorList[0].dateOfBirth).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })}</Card.Text>
                                </Col>
                              </Row>
                              <hr />
                            </Col>
                          </Row> */}
                          <Row>
                            <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>Network</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted text-capitalize"> {doctorList[0].network}</Card.Text>
                                </Col>
                              </Row>
                              <hr />
                            </Col>
                            <Col xs="12" sm="12" md="6" lg="6">
                              <Row>
                                <Col xs="12" sm="3" md="5" lg="6">
                                  <Card.Text>Phone</Card.Text>
                                </Col>
                                <Col xs="12" sm="9" md="7" lg="6">
                                  <Card.Text className="text-muted">{doctorList[0].contactNumber}</Card.Text>
                                </Col>
                              </Row>
                              <hr />
                            </Col>
                          </Row>

                          <Row>
                            <Col xs="12" sm="3" md="3" lg="3">
                              <Card.Text>Address</Card.Text>
                            </Col>
                            <Col xs="12" sm="9" md="7" lg="9">
                              <Card.Text className="text-muted">{doctorList[0].address}</Card.Text>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          )
        }


      </Row>

      {/* Professional Information */}
      <Row className='d-flex justify-content-center h-45 mt-3'>
        {doctorList.length > 0 && (
          <Col xs="12" sm="12" md="12" lg="6" className="mt-1 mb-3">
            <Card className='card-registration card-registration-2 sha' style={{ borderRadius: '15px' }}>
              <Card.Header className="text-center bg_primary text-white">
                <Row>
                  <Col xs="9" sm="8" md="10" lg="9">
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <h5 className="fw-bold mb-1">Professional Information</h5>
                    </div>
                  </Col>
                  <Col xs="3" sm="4" md="2" lg="3">
                    <div className="d-flex justify-content-center align-items-center">
                      <Button color="primary" className="w-100 bg-white text_primary px-0" variant="primary" size="md" onClick={handleInfoEditClick}>Edit</Button>
                    </div>
                  </Col>
                </Row>
              </Card.Header>

              <Card.Body className='p-0'>
                <Row>
                  <Col md="12">
                    <Card className="shadow-none">
                      <Card.Body>

                        <Row>
                          <Col xs="12" sm="12" md="6" lg="6" className='mb-2'>
                            <Row>
                              <Col xs="6" sm="3" md="6" lg="6">
                                <Card.Text>Medical Degree</Card.Text>
                              </Col>
                              <Col xs="6" sm="9" md="6" lg="6">
                                <Card.Text className="text-muted">
                                  {doctorList[0].medicalDegree ? (
                                    doctorList[0].medicalDegree.startsWith('http') ? (
                                      <a href={doctorList[0].medicalDegree} target="_blank" rel="noopener noreferrer">
                                        <Button color="primary" size="sm" className='btn_primary'>Download</Button>
                                      </a>
                                    ) : (
                                      <Button color="primary" size="sm" className='btn_primary' href={doctorList[0].medicalDegree} download>
                                        Download
                                      </Button>
                                    )
                                  ) : 'Not Uploaded'}
                                </Card.Text>
                              </Col>
                            </Row>
                            <hr />
                          </Col>
                          <Col xs="12" sm="12" md="6" lg="6" className='mb-2'>
                            <Row>
                              <Col xs="6" sm="3" md="6" lg="6">
                                <Card.Text>Resume</Card.Text>
                              </Col>
                              <Col xs="6" sm="9" md="6" lg="6">
                                <Card.Text className="text-muted">
                                  {doctorList[0].resume ? (
                                    doctorList[0].resume.startsWith('http') ? (
                                      <a href={doctorList[0].resume} target="_blank" rel="noopener noreferrer">
                                        <Button color="primary" size="sm" className='btn_primary'>Download</Button>
                                      </a>
                                    ) : (
                                      <Button color="primary" size="sm" className='btn_primary' href={doctorList[0].resume} download>
                                        Download
                                      </Button>
                                    )
                                  ) : 'Not Uploaded'}
                                </Card.Text>
                              </Col>
                            </Row>
                            <hr />
                          </Col>
                        </Row>


                        <Row>
                          <Col xs="12" sm="12" md="6" lg="6">
                            <Row>
                              <Col xs="12" sm="3" md="6" lg="6">
                                <Card.Text>Medical Institute</Card.Text>
                              </Col>
                              <Col xs="12" sm="9" md="6" lg="6">
                                <Card.Text className="text-muted">{doctorList[0].instituteName || 'N/A'}</Card.Text>

                              </Col>
                            </Row>
                            <hr />
                          </Col>
                          <Col xs="12" sm="12" md="6" lg="6">
                            <Row>
                              <Col xs="12" sm="3" md="6" lg="6">
                                <Card.Text>Institute Country</Card.Text>
                              </Col>
                              <Col xs="12" sm="9" md="6" lg="6">
                                <Card.Text className="text-muted">{doctorList[0].instituteCountry || 'N/A'}</Card.Text>

                              </Col>
                            </Row>
                            <hr />
                          </Col>
                        </Row>


                        <Row>
                          <Col xs="12" sm="12" md="6" lg="6">
                            <Row>
                              <Col xs="12" sm="3" md="6" lg="6">
                                <Card.Text>Experience</Card.Text>
                              </Col>
                              <Col xs="12" sm="9" md="6" lg="6">
                                <Card.Text className="text-muted">{doctorList[0].experience || 'Not Inserted'}</Card.Text>

                              </Col>
                            </Row>
                            <hr className='d_block' style={{ display: "none" }} />
                          </Col>
                          <Col xs="12" sm="12" md="6" lg="6">
                            <Row>
                              <Col xs="12" sm="3" md="6" lg="6">
                                <Card.Text>License No</Card.Text>
                              </Col>
                              <Col xs="12" sm="9" md="6" lg="6">
                                <Card.Text className="text-muted">{doctorList[0].licenseNo || 'Not Inserted'}</Card.Text>
                              </Col>
                            </Row>

                          </Col>

                        </Row>

                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        )}

        {/* Admin Information */}
        {doctorList.length > 0 && (
          <Col xs="12" sm="12" md="12" lg="6" className="mt-1">
            <Card className='card-registration card-registration-2' style={{ borderRadius: '15px' }}>
              <Card.Header className="text-center bg_primary text-white">
                <h5 className="fw-bold mb-1">Approved Admin Information</h5>
              </Card.Header>

              <Card.Body className='p-0'>
                <Row>
                  <Col md="12">
                    <Card className="shadow-none">
                      <Card.Body>
                        <Row className="mt-1">
                          <Col md="6" lg="6" >
                            <Card.Text>Consultation Fee</Card.Text>
                          </Col>
                          <Col md="6" lg="6" >
                            <Card.Text className="text-muted">{doctorList[0].consultationFee || 'N/A'}/- {doctorList[0].currency || 'PKR'}</Card.Text>
                          </Col>
                        </Row>

                        <hr />
                        <Row className="mt-1">
                          <Col md="6" lg="6" >
                            <Card.Text>Admin Remarks</Card.Text>
                          </Col>
                          <Col md="6" lg="6" >
                            <Card.Text className="text-muted">{doctorList[0].adminRemarks || 'N/A'}</Card.Text>
                          </Col>
                        </Row>

                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Card.Body>

            </Card>
          </Col>
        )}
      </Row>
    </Container>
  );
}
